import { Outlet } from 'react-router-dom';

export default function MethodFees() {
    return (
        <Outlet />
    )
}
